import React, { Component } from 'react';
import UISide from '../component/UISide';
import Player from '../component/Player';
export default class Product extends Component {
  render() {
    const { product, api, loaded, size, setAppState, initConfig } = this.props;

    return (
      <div className="app-body product">
        <Player
          product={product}
          loaded={loaded}
          setAppState={setAppState}
          initConfig={initConfig}
        />
        <UISide
          product={product}
          api={api}
          loaded={loaded}
          setAppState={setAppState}
          initConfig={initConfig}
          size={size}
        />
        <div id="config-init-div" style={{ display: 'none' }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Product.js